import React, { useState, useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { Splide, SplideTrack, SplideSlide } from "@splidejs/react-splide";
import { useDispatch, useSelector } from "react-redux";
import { tableHandler } from "../../redux/handlers";

export default function ModalTableSelect({
  modalOpenObj,
  handleTableSelect,
  businessSlug,
  currentCustomerCount = 1,
  currentOrder = null,
  onTableOpenSuccess,
  orderId,
  ...props
}) {
  const dispatch = useDispatch();

  const tableData = useSelector((state) => state.table?.data);
  const tableZone = useSelector((state) => state.table?.zone);

  const currentBranchId = localStorage.getItem("branchId");
  const [tableCardList, setTableCardList] = useState([]);
  const [tableZoneBtnList, setTableZoneBtnList] = useState([]);
  const [zoneSelected, setZoneSelected] = useState(0);
  const [currentZone, setCurrentZone] = useState(0);
  const [tableSelected, setTableSelected] = useState(null);
  const [checkTime, setCheckTime] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [isFormDisabled, setIsFormDisabled] = useState(false);

  const [time, setTime] = useState({
    hour: "00",
    minute: "00",
  });

  useEffect(() => {
    if (currentOrder && currentOrder.tableID) {
      setIsFormDisabled(true);
    } else {
      setIsFormDisabled(false);
    }
  }, [currentOrder]);

  useEffect(() => {
    if (modalOpenObj.modalOpen) {
      if (currentOrder && currentOrder.tableDetails && currentOrder.tableID) {
        const existingTable = tableCardList.find(
          (table) => table.tableID === currentOrder.tableID
        );
        if (existingTable) {
          setTableSelected({
            currentPerson:
              currentOrder.tableDetails.currentPerson || currentCustomerCount,
            timeUp: currentOrder.tableDetails.timeUp || "",
            maxPerson: existingTable.maxPerson,
            time: existingTable.time,
            type: "using",
            tableNo: existingTable.tableNo,
            tableID: existingTable.tableID,
            mergeList: existingTable.mergeList,
            moveFrom: existingTable.moveFrom,
          });

          if (currentOrder.tableDetails.timeUp) {
            setCheckTime(true);
            const [hours, minutes] =
              currentOrder.tableDetails.timeUp.split(":");
            setTime({
              hour: hours || "00",
              minute: minutes || "00",
            });
          } else {
            setCheckTime(false);
            setTime({
              hour: "00",
              minute: "00",
            });
          }
        } else {
          setTableSelected(null);
          setCheckTime(false);
          setTime({
            hour: "00",
            minute: "00",
          });
        }
      } else {
        setTableSelected(null);
        setCheckTime(false);
        setTime({
          hour: "00",
          minute: "00",
        });
      }
    }
  }, [
    modalOpenObj.modalOpen,
    currentOrder,
    tableCardList,
    currentCustomerCount,
  ]);

  useEffect(() => {
    if (businessSlug && modalOpenObj.modalOpen) {
      dispatch(tableHandler.getAllTableZone(businessSlug, currentBranchId));
    }
  }, [dispatch, businessSlug, modalOpenObj.modalOpen, currentBranchId]);

  useEffect(() => {
    if (tableZone && tableZone.length > 0) {
      let temp = [];
      tableZone.forEach((item) => {
        temp.push({
          zoneID: item?.id,
          zoneName: item?.name,
        });
      });

      setTableZoneBtnList(temp);

      let zoneToSelect = 0;
      let zoneIdToFetch = temp[0]?.zoneID;

      if (currentOrder && currentOrder.tableID && currentOrder.zoneID) {
        const previousZoneIndex = temp.findIndex(
          (zone) => zone.zoneID === currentOrder.zoneID
        );

        if (previousZoneIndex !== -1) {
          zoneToSelect = previousZoneIndex;
          zoneIdToFetch = temp[previousZoneIndex].zoneID;
        }
      }

      if (temp.length > 0) {
        setZoneSelected(zoneToSelect);
        setCurrentZone(zoneIdToFetch);
      }
    }
  }, [tableZone, currentOrder]);

  useEffect(() => {
    if (currentZone && businessSlug) {
      dispatch(tableHandler.getAllTableData(businessSlug, currentZone));
    }
  }, [currentZone, businessSlug, dispatch]);

  useEffect(() => {
    if (tableData) {
      const updatedTableList = tableData.map((item) => {
        const tableStatus = item?.table_status || "AVALIABLE";

        let type = "empty";
        if (tableStatus === "IN_USE") {
          type = "using";
        } else if (
          tableStatus === "AVALIABLE" &&
          item?.table_reservations &&
          item?.table_reservations.length > 0
        ) {
          type = "reserved";
        } else if (tableStatus === "MERGED") {
          type = "using";
        }

        const formatTime = (isoString) => {
          if (!isoString) return "";
          const date = new Date(isoString);
          return date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
        };

        const reservation =
          item?.table_reservations && item?.table_reservations.length > 0
            ? item.table_reservations[0]
            : null;

        const currentPerson = reservation ? reservation.total_guest : 0;

        const time = reservation
          ? formatTime(reservation.reservation_time)
          : "";

        const mergeList =
          item?.merged_tables?.length > 0
            ? item.merged_tables
                .map((mergedTable) => mergedTable.table_name)
                .join(", ")
            : "";

        const moveFrom =
          item?.moved_from_tables?.length > 0
            ? item.moved_from_tables
                .map((movedTable) => movedTable.table_name)
                .join(", ")
            : "";

        return {
          tableNo: item?.table_name,
          tableID: item?.table_id,
          maxPerson: item?.seat_capacity || 4,
          currentPerson: currentPerson,
          time: time,
          type: type,
          mergeList: mergeList,
          moveFrom: moveFrom,
          ...item,
        };
      });

      setTableCardList(updatedTableList);
    }
  }, [tableData]);

  const handleZoneChange = (zoneIndex, zoneId) => {
    // ถ้า form ถูก disable แล้ว ให้ไม่ทำอะไรเลย
    if (isFormDisabled) return;

    setZoneSelected(zoneIndex);
    setCurrentZone(zoneId);

    if (!currentOrder?.tableID || currentOrder.zoneID !== zoneId) {
      setTableSelected(null);
    }
  };

  const formatTimeForDisplay = (hour, minute) => {
    return `${hour.padStart(2, "0")}:${minute.padStart(2, "0")}`;
  };

  const handleOpenTable = async () => {
    if (tableSelected && !isFormDisabled) {
      setIsLoading(true);
      try {
        let timeDuration = 0;

        if (checkTime) {
          const now = new Date();
          const selectedHour = parseInt(time.hour, 10);
          const selectedMinute = parseInt(time.minute, 10);
          const targetTime = new Date();
          targetTime.setHours(selectedHour, selectedMinute, 0);

          if (targetTime < now) {
            targetTime.setDate(targetTime.getDate() + 1);
          }

          const diffMs = targetTime - now;
          timeDuration = Math.round(diffMs / 60000);
          timeDuration = Math.max(15, timeDuration);
        }

        const tableInUseData = {
          branch_table_id: tableSelected.tableID,
          seat: tableSelected.currentPerson,
          time_duration: timeDuration,
        };
        if (
          currentOrder &&
          currentOrder.orderNo &&
          !currentOrder.tableID &&
          orderId
        ) {
          await dispatch(
            tableHandler.updateOrderTable(businessSlug, orderId, {
              branch_table_id: tableSelected.tableID,
            })
          );
        }
        await dispatch(
          tableHandler.setTableInUse(businessSlug, tableInUseData)
        );

        const selectedZoneInfo = tableZoneBtnList[zoneSelected];
        const tableDetailsData = {
          ...tableSelected,
          zoneID: currentZone,
          zoneName: selectedZoneInfo ? selectedZoneInfo.zoneName : "",
          time: checkTime
            ? {
                hour: time.hour,
                minute: time.minute,
              }
            : { hour: "00", minute: "00" },
          isTimeLimit: checkTime,
          timeUp: checkTime ? formatTimeForDisplay(time.hour, time.minute) : "",
          timeDuration: timeDuration,
        };

        const tableInfo = {
          tableID: tableDetailsData.tableID,
          zoneID: tableDetailsData.zoneID,
          tableDetails: tableDetailsData,
        };

        handleTableSelect(tableInfo);

        if (onTableOpenSuccess && typeof onTableOpenSuccess === "function") {
          await onTableOpenSuccess();
        }

        modalOpenObj.setModalOpen(false);
      } catch (error) {
        console.error("Error opening table:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modalOpenObj.modalOpen}
        onClose={() => modalOpenObj.setModalOpen(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={modalOpenObj.modalOpen}>
          <div className="bg-white focus-visible-none w-[min(90.11vw,785px)] pt-1 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)] text-16 text-[var(--color-black-2)]">
            <div className="text-end mb-2">
              <div className="d-flex align-items-center mb-3 px-4 pt-4 pb-1">
                <div className="icon-desk fs-24 tc-2 fw-5 me-auto">
                  เลือกโต๊ะ
                </div>

                <div className="d-flex align-items-center pe-0">
                  <div className="form-check form-check-st-2 me-3">
                    <input
                      className="form-check-input timecheck"
                      type="checkbox"
                      value=""
                      id="timecheck"
                      style={{ marginTop: "2.5px" }}
                      checked={checkTime}
                      onChange={(e) => {
                        if (isFormDisabled) return;

                        const isChecked = e.target.checked;
                        setCheckTime(isChecked);

                        if (!isChecked) {
                          setTime({
                            hour: "00",
                            minute: "00",
                          });

                          if (tableSelected) {
                            setTableSelected((prev) => ({
                              ...prev,
                              timeUp: "",
                            }));
                          }
                        }
                      }}
                      disabled={isFormDisabled}
                    />
                    <label className="form-check-label fs-18 fw-5 tc-2 ps-3">
                      กำหนดเวลา
                    </label>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="d-flex align-items-center">
                      <div>
                        <input
                          type="text"
                          className="form-control form-time"
                          readOnly={!checkTime || isFormDisabled}
                          value={time.hour}
                          onChange={(e) => {
                            if (isFormDisabled) return;

                            const value = e.target.value.replace(/[^0-9]/g, "");

                            const newValue = value.substring(0, 2);

                            let finalValue = newValue;
                            if (newValue.length === 2) {
                              const hourNum = parseInt(newValue, 10);
                              if (hourNum > 23) {
                                finalValue = "23";
                              }
                            }

                            setTime((prev) => ({ ...prev, hour: finalValue }));
                            if (tableSelected && checkTime) {
                              setTableSelected((prev) => ({
                                ...prev,
                                timeUp: formatTimeForDisplay(
                                  finalValue,
                                  time.minute
                                ),
                              }));
                            }
                          }}
                          onBlur={(e) => {
                            if (isFormDisabled) return;

                            const value = e.target.value;
                            const paddedValue = value.padStart(2, "0");
                            setTime((prev) => ({ ...prev, hour: paddedValue }));
                            if (tableSelected && checkTime) {
                              setTableSelected((prev) => ({
                                ...prev,
                                timeUp: formatTimeForDisplay(
                                  paddedValue,
                                  time.minute
                                ),
                              }));
                            }
                          }}
                          disabled={isFormDisabled}
                        />
                      </div>
                      <div className="fs-18 tc-14 mx-1"> : </div>
                      <div>
                        <input
                          type="text"
                          className="form-control form-time"
                          readOnly={!checkTime || isFormDisabled}
                          value={time.minute}
                          onChange={(e) => {
                            if (isFormDisabled) return;

                            const value = e.target.value.replace(/[^0-9]/g, "");

                            const newValue = value.substring(0, 2);

                            let finalValue = newValue;
                            if (newValue.length === 2) {
                              const minuteNum = parseInt(newValue, 10);
                              if (minuteNum > 59) {
                                finalValue = "59";
                              }
                            }

                            setTime((prev) => ({
                              ...prev,
                              minute: finalValue,
                            }));
                            if (tableSelected && checkTime) {
                              setTableSelected((prev) => ({
                                ...prev,
                                timeUp: formatTimeForDisplay(
                                  time.hour,
                                  finalValue
                                ),
                              }));
                            }
                          }}
                          onBlur={(e) => {
                            if (isFormDisabled) return;

                            const value = e.target.value;
                            const paddedValue = value.padStart(2, "0");
                            setTime((prev) => ({
                              ...prev,
                              minute: paddedValue,
                            }));
                            if (tableSelected && checkTime) {
                              setTableSelected((prev) => ({
                                ...prev,
                                timeUp: formatTimeForDisplay(
                                  time.hour,
                                  paddedValue
                                ),
                              }));
                            }
                          }}
                          disabled={isFormDisabled}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="px-5"></div>
                </div>
                <button
                  type="button"
                  className="btn btn-close-modal"
                  onClick={() => modalOpenObj.setModalOpen(false)}
                ></button>
              </div>

              <div className="px-3 py-3" style={{ background: "#FAFAFA" }}>
                <div className="mb-3 px-5">
                  <Splide
                    hasTrack={false}
                    options={{
                      autoWidth: true,
                      pagination: false,
                    }}
                  >
                    <div className="custom-wrapper">
                      <SplideTrack>
                        {tableZoneBtnList.map((item, index) => (
                          <SplideSlide key={index}>
                            <button
                              className={
                                index === zoneSelected
                                  ? "btn btn-category category btn-c1 active"
                                  : "btn btn-category category btn-c1"
                              }
                              onClick={() =>
                                handleZoneChange(index, item.zoneID)
                              }
                              style={{ minWidth: "100px" }}
                              disabled={isFormDisabled}
                            >
                              {item.zoneName}
                            </button>
                          </SplideSlide>
                        ))}
                      </SplideTrack>
                      <div className="splide__arrows">
                        <button
                          className="splide__arrow btn-scroll-prev splide__arrow--prev"
                          disabled={isFormDisabled}
                        ></button>
                        <button
                          className="splide__arrow btn-scroll-next splide__arrow--next"
                          disabled={isFormDisabled}
                        ></button>
                      </div>
                    </div>
                  </Splide>
                </div>

                <div className="bg-white p-3 ps-4">
                  <div className="d-flex align-items-center mb-2">
                    <div className="bx-alert-a1 me-auto">กรุณาเลือกโต๊ะ</div>
                    <div>
                      <span className="tc-8 fw-light u-off me-3">
                        ไม่สามารถเปิดได้
                      </span>
                      <span className="tc-8 fw-light u-on me-3">เปิดได้</span>
                    </div>
                  </div>

                  <div
                    className={`bx-list-desk-m ${
                      isFormDisabled ? "pointer-events-none opacity-75" : ""
                    }`}
                  >
                    {tableCardList &&
                      tableCardList.map((item, index) => (
                        <button
                          key={item.tableID || index}
                          className={`bx-desk ${
                            item.type === "empty"
                              ? "available"
                              : item.type === "reserved"
                              ? "reserved"
                              : "occupied"
                          } ${
                            tableSelected &&
                            tableSelected.tableID === item.tableID
                              ? "active"
                              : ""
                          }`}
                          onClick={() => {
                            if (isFormDisabled) return;

                            if (
                              item.type === "empty" ||
                              item.type === "reserved"
                            ) {
                              setTableSelected({
                                currentPerson: currentCustomerCount,
                                timeUp: checkTime
                                  ? formatTimeForDisplay(time.hour, time.minute)
                                  : "",
                                maxPerson: item.maxPerson,
                                time: item.time,
                                type: "using",
                                tableNo: item.tableNo,
                                tableID: item.tableID,
                                mergeList: item.mergeList,
                                moveFrom: item.moveFrom,
                              });
                            }
                          }}
                          disabled={
                            (item.type !== "empty" &&
                              item.type !== "reserved") ||
                            isFormDisabled
                          }
                        >
                          <label>
                            <div className="fs-10 mb-auto d-flex align-items-center justify-content-between tx1">
                              <span className="icustomer">
                                {item.currentPerson}/{item.maxPerson}
                              </span>
                              <span className="iclock">{item.time}</span>
                            </div>
                            <div className="text-end">
                              <div className="tx2">
                                {item.type === "reserved" ? "จอง" : ""}
                              </div>
                              <div className="tx3">{item.tableNo}</div>
                            </div>
                          </label>
                        </button>
                      ))}
                  </div>
                </div>
              </div>

              <div className="px-3 pt-3 pb-3">
                <div className="d-flex ps-3">
                  <div className="me-auto d-flex align-items-center">
                    <div className="me-4 tc-2">จำนวนคน</div>
                    <div className="d-flex align-items-center">
                      <button
                        className="btn btn-minus"
                        disabled={
                          (tableSelected && tableSelected.currentPerson <= 1) ||
                          !tableSelected ||
                          isLoading ||
                          isFormDisabled
                        }
                        onClick={() => {
                          if (isFormDisabled) return;

                          if (
                            tableSelected &&
                            tableSelected.currentPerson > 1
                          ) {
                            setTableSelected((prev) => ({
                              ...prev,
                              currentPerson: Math.max(
                                1,
                                prev.currentPerson - 1
                              ),
                            }));
                          }
                        }}
                      ></button>
                      <input
                        type="number"
                        className="form-control-plaintext plaintext1 mx-4"
                        readOnly
                        value={
                          tableSelected
                            ? tableSelected.currentPerson
                            : currentCustomerCount
                        }
                      />
                      <button
                        className="btn btn-plus"
                        onClick={() => {
                          if (isFormDisabled) return;

                          if (tableSelected) {
                            setTableSelected((prev) => ({
                              ...prev,
                              currentPerson: prev.currentPerson + 1,
                            }));
                          }
                        }}
                        disabled={
                          (tableSelected
                            ? tableSelected.currentPerson >=
                              tableSelected.maxPerson
                            : true) ||
                          isLoading ||
                          isFormDisabled
                        }
                      ></button>
                    </div>
                  </div>
                  <div className="pe-3">
                    <button
                      className="btn btn-m2 me-2"
                      onClick={() => modalOpenObj.setModalOpen(false)}
                      disabled={isLoading}
                    >
                      ยกเลิก
                    </button>
                    <button
                      className="btn btn-m3 btn-select-table"
                      disabled={!tableSelected || isLoading || isFormDisabled}
                      onClick={handleOpenTable}
                    >
                      {isLoading ? "กำลังดำเนินการ..." : "เปิดโต๊ะ"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
